export default __webpack_public_path__ + "static/media/first-icon.e1ee6403.svg";